import { Draft } from './Draft';
import { TripType } from '@qover-private/protos-web/qover/dojo/travel/v1/terms';
import { PaymentRequest as PaymentRequestModel } from '@qover/domain';

export class PaymentRequest extends PaymentRequestModel<Draft> {
  constructor(draft: Draft, token: string, returnUrl: string) {
    super(
      draft,
      token,
      returnUrl,
      draft?.terms?.tripType === TripType.TRIP_TYPE_SINGLE_TRIP
        ? 'ONE_TIME'
        : 'MONTHLY',
    );
  }
}
